declare namespace $ {

	export class $shm_projects_codex_prompt_edit extends $mol_textarea_edit {
		scroll_event( next?: any ): any
		scroll_top( next?: number ): number
		field( ): ({ 
			'scrollTop': ReturnType< $shm_projects_codex_prompt_edit['scroll_top'] >,
		})  & ReturnType< $mol_textarea_edit['field'] >
		event( ): ({ 
			scroll( next?: ReturnType< $shm_projects_codex_prompt_edit['scroll_event'] > ): ReturnType< $shm_projects_codex_prompt_edit['scroll_event'] >,
		})  & ReturnType< $mol_textarea_edit['event'] >
	}
	
	type $mol_hotkey__key_shm_projects_codex_prompt_1 = $mol_type_enforce<
		({ 
			enter( next?: ReturnType< $shm_projects_codex_prompt['enter_key'] > ): ReturnType< $shm_projects_codex_prompt['enter_key'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $shm_projects_codex_prompt_edit__value_shm_projects_codex_prompt_2 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['value'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['value'] >
	>
	type $shm_projects_codex_prompt_edit__hint_shm_projects_codex_prompt_3 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['hint'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['hint'] >
	>
	type $shm_projects_codex_prompt_edit__enabled_shm_projects_codex_prompt_4 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['enabled'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['enabled'] >
	>
	type $shm_projects_codex_prompt_edit__spellcheck_shm_projects_codex_prompt_5 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['spellcheck'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['spellcheck'] >
	>
	type $shm_projects_codex_prompt_edit__length_max_shm_projects_codex_prompt_6 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['length_max'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['length_max'] >
	>
	type $shm_projects_codex_prompt_edit__selection_shm_projects_codex_prompt_7 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['selection'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['selection'] >
	>
	type $shm_projects_codex_prompt_edit__submit_shm_projects_codex_prompt_8 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['submit'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['submit'] >
	>
	type $shm_projects_codex_prompt_edit__submit_with_ctrl_shm_projects_codex_prompt_9 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['submit_with_ctrl'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['submit_with_ctrl'] >
	>
	type $shm_projects_codex_prompt_edit__scroll_top_shm_projects_codex_prompt_10 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['scroll_top'] >
		,
		ReturnType< $shm_projects_codex_prompt_edit['scroll_top'] >
	>
	type $mol_text_code__text_shm_projects_codex_prompt_11 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['value'] >
		,
		ReturnType< $mol_text_code['text'] >
	>
	type $mol_text_code__render_visible_only_shm_projects_codex_prompt_12 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_text_code['render_visible_only'] >
	>
	type $mol_text_code__row_numb_shm_projects_codex_prompt_13 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['row_numb'] >
		,
		ReturnType< $mol_text_code['row_numb'] >
	>
	type $mol_text_code__sidebar_showed_shm_projects_codex_prompt_14 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['sidebar_showed'] >
		,
		ReturnType< $mol_text_code['sidebar_showed'] >
	>
	type $mol_text_code__highlight_shm_projects_codex_prompt_15 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['highlight'] >
		,
		ReturnType< $mol_text_code['highlight'] >
	>
	type $mol_text_code__syntax_shm_projects_codex_prompt_16 = $mol_type_enforce<
		ReturnType< $shm_projects_codex_prompt['syntax'] >
		,
		ReturnType< $mol_text_code['syntax'] >
	>
	type $mol_text_code__style_shm_projects_codex_prompt_17 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_projects_codex_prompt['scroll_transform'] >,
		})  & ReturnType< $mol_text_code['style'] >
		,
		ReturnType< $mol_text_code['style'] >
	>
	export class $shm_projects_codex_prompt extends $mol_textarea {
		Enter_submit( ): $mol_hotkey
		bring( ): ReturnType< ReturnType< $shm_projects_codex_prompt['Edit'] >['bring'] >
		scroll_transform( ): string
		scroll_top( next?: number ): number
		enter_submit( next?: any ): any
		enter_key( next?: any ): any
		plugins( ): readonly(any)[]
		Edit( ): $shm_projects_codex_prompt_edit
		View( ): $mol_text_code
	}
	
}

//# sourceMappingURL=prompt.view.tree.d.ts.map